import {Vue} from 'ui.vue';



import './BXmakerAuthuserphoneSimpleUserCall.styl';


Vue.component('BXmakerAuthuserphoneSimpleUserCall',
    {
        props: [

        ],
        data: function () {
            return {
                //последняя операция была - проверка?
                // для повторения операции после ввода капчи - при необходимости
                lastActionCheck: false,
            };
        },
        created() {
            this.unsubscribe = this.$Bitrix.PullClient.get().subscribe({
                moduleId: 'bxmaker.authuserphone',
                command: 'COMMAND_CALL_USER_CHECK',
                callback: () => {
                    if (this.$root.isNeedShowConfirmUserCall) {
                        this.onClickCheck();
                    }
                }
            });

        },
        beforeDestroy() {
            if (typeof this.unsubscribe == 'function') {
                this.unsubscribe();
            }
        },
        computed: {

        },
        methods: {
            onClickCheck() {
                this.lastActionCheck = true;
                this.$root.authByPhone();
            },
            onClickChangePhone() {
                this.lastActionCheck = false;
                this.$root.resetMessage();
                this.$root.resetCaptcha();
                this.$root.hideConfirm();
            },
            onClickStart() {
                this.lastActionCheck = false;
                this.$root.startConfirmUserCall();
            },
            onCompleteCaptcha() {
                //повторяем операцию последнюю
                if (this.lastActionCheck) {
                    this.onClickCheck();                    
                } else {
                    this.onClickStart();
                }
            },
            onCompleteTimeout(){
                this.$root.setUserCallTimeout(0);
            }
        },
        template: `
            <div class="bxmaker-authuserphone-simple-usercall"  >
              
                <slot name="header">                  
                    <BXmakerAuthuserphoneHeader>
                        {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_USER_CALL_TITLE}}
                    </BXmakerAuthuserphoneHeader>     
                </slot>
                
                <slot name="message">
                    <BXmakerAuthuserphoneMessage :message="$root.message" :error="$root.error" />  
                </slot>                  
                    
                <slot name="notice">
                    <div class="bxmaker-authuserphone-simple-usercall__notice">
                         {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_USER_CALL_NOTICE}} 
                         
                         <span class="bxmaker-authuserphone-simple-usercall__phone">{{$root.formattedPhone}}</span>
                         
                         <BXmakerAuthuserphoneLink @onClick="onClickChangePhone">
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_USER_CALL_CHANGE_PHONE}}
                         </BXmakerAuthuserphoneLink>                     
                    </div>
                </slot>
                
                <slot name="callTo">
                    <BXmakerAuthuserphoneUserCallTo
                        :value="$root.userCallTo"
                        :loader="$root.userCallStartLoader"
                    />
                </slot>
                               
                <slot name="captcha">
                    <BXmakerAuthuserphoneCaptcha 
                        :code="$root.captchaCode"
                        :src="$root.captchaSrc"
                        :length="$root.captchaLength"
                        :loader="$root.captchaLoader"
                        @onInput="$root.setCaptchaCode"
                        @onComplete="onCompleteCaptcha"
                        @onRefresh="$root.refreshCaptcha"
                   />
                </slot>
                
                 <slot name="timeout">
                    <BXmakerAuthuserphoneTimeout 
                    :timeout="$root.userCallTimeout"
                     v-if="$root.userCallTimeout"
                     @onComplete="onCompleteTimeout" >  
                        <template v-slot:before>
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_USER_CALL_TIMEOUT_TITLE}} <br>
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_USER_CALL_TIMEOUT_SUBTITLE}} 
                        </template>       
                     </BXmakerAuthuserphoneTimeout>  
                 </slot>             
                
                <slot name="request"  v-if="!$root.userCallTimeout">          
                    <div class="bxmaker-authuserphone-simple-usercall__start">
                        <BXmakerAuthuserphoneLink @onClick="onClickStart" v-if="!$root.userCallStartLoader">
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_USER_CALL_GET_NEW}}   
                         </BXmakerAuthuserphoneLink> 
                         <BXmakerAuthuserphoneLoader class="bxmaker-authuserphone-simple-usercall__start-loader" v-else />
                    </div>   
                </slot>                
                          
                <slot name="check">          
                    <BXmakerAuthuserphoneButton 
                        class="bxmaker-authuserphone-simple-usercall__button-check"
                        :title="$root.localize.BXMAKER_AUTHUSERPHONE_SIMPLE_USER_CALL_BUTTON_CHECK"  
                        :loader="$root.userCallCheckLoader"
                        @onClick="onClickCheck" 
                    />       
                </slot>
                                
            </div>
        `,
    });